import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import role from 'role';

export default function RootTermList({ match }) {
    
    const fields = [
        { name: 'Id', key: 'id' },
        { name: 'Root Term Type (EN)', keys: ['rootTermType', 'termTypeNameEN'] },
        { name: 'Root Term Type (ES)', keys: ['rootTermType', 'termTypeNameES'] },
        { name: 'Root Term Name (EN)', key: 'rootTermNameEN' },
        { name: 'Root Term Name (ES)', key: 'rootTermNameES' },
    ];

    return (
        <ListCRUD
            plural='rootTerms'
            singular='rootTerm'
            fields={fields}
            match={match}
            disableViewButton
            canEdit={[role.ADMIN]}
            canNew={[role.ADMIN]}
        />
    );
}